import React, { useState, useEffect } from 'react';
import './Menu.css';
import logo from '../../assets/img/RezGlobal.png'
import { Link, NavLink} from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { FaCar } from "react-icons/fa";
import { MdAccountBalance } from "react-icons/md";
import { ImLocation2 } from "react-icons/im";
import { RiUserSettingsFill } from "react-icons/ri";
import { FaUserGroup } from "react-icons/fa6";
import { PiMonitorFill } from "react-icons/pi";
import { PiNotebookFill } from "react-icons/pi";
import { FaRoute } from "react-icons/fa";
import { FaDatabase } from "react-icons/fa6";
import { AiFillDashboard } from "react-icons/ai";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";
import { MdSatelliteAlt } from "react-icons/md";
import { HiMiniBellAlert } from "react-icons/hi2";
import { SiFord } from "react-icons/si";
import { FaToriiGate } from "react-icons/fa";
import { baseURL } from '../base_url';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRoad } from '@fortawesome/free-solid-svg-icons';
import { FaCarSide } from 'react-icons/fa';
import { MdGpsFixed } from 'react-icons/md';
import {TbCurrencyEuro  } from "react-icons/tb"; // location tax
import { BiSolidReport } from "react-icons/bi";  // BCF report
import { HiOutlineStatusOnline } from "react-icons/hi"; // fleet status
import { LuActivity } from "react-icons/lu"; // asa
import { HiOutlineExclamationTriangle } from "react-icons/hi2"; // stolen vehicle
import { MdOutlineManageHistory } from "react-icons/md"; // fleet logs
import { MdOutlineRateReview } from "react-icons/md"; // audit logs
import { CiBookmarkCheck } from "react-icons/ci"; // eligibility
import { FaCarOn } from "react-icons/fa6"; // fetch fleet
import { TbCarOff } from "react-icons/tb"; // remove fleet
import { GoTasklist } from "react-icons/go"; // sqs enroll
import { FaAddressCard } from "react-icons/fa"; // kinesis enroll
import { IoMdCheckmarkCircleOutline } from "react-icons/io"; // compatibility check
import { FaHandshake } from "react-icons/fa"; // onboard
import { FaHandshakeSimpleSlash } from "react-icons/fa6"; // offboard
import { HiDotsHorizontal } from "react-icons/hi"; // status
import { MdOnDeviceTraining } from "react-icons/md"; // device
import { BsCalendarEventFill } from "react-icons/bs"; // event
import { FaMapLocationDot } from "react-icons/fa6";
import { GoChevronUp } from "react-icons/go";
import { FiChevronDown } from "react-icons/fi"; 
import { FileText } from "lucide-react";
import { BsQrCode } from "react-icons/bs";
import { SiNissan } from "react-icons/si";


export default function LeftMenu() {
  const [searchModuleName, setSearchModuleName] = useState("");
  const [menuItemsFinal, setMenuItemsFinal] = useState([]);
  const [showSubMenu, setShowSubMenu] = useState(false);

  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);

  const iconHash = {
    "Dashboard": <MdDashboard style={{fontSize:'20px'}}/>,
    "Company": <MdAccountBalance style={{fontSize:'20px'}}/>,
    "Location": <ImLocation2 style={{fontSize:'20px'}}/>,
    "Fleet": <FaCar style={{fontSize:'20px'}}/>,
    "Access Setup": <RiUserSettingsFill style={{fontSize:'20px'}}/>,
    "User": <FaUserGroup style={{fontSize:'20px'}}/>,
    "Monitor": <PiMonitorFill style={{fontSize:'20px'}}/>,
    "Reports": <FaDatabase style={{fontSize:'20px'}}/>,
    "BCF Reports": <FaDatabase style={{fontSize:'20px'}}/>,
    "Activity": <PiNotebookFill style={{fontSize:'20px'}}/>,
    "Fleet Logs": <PiNotebookFill style={{fontSize:'20px'}}/>,
    "Fleet Status": <PiNotebookFill style={{fontSize:'20px'}}/>,
    "r_dashboard": <AiFillDashboard style={{fontSize:'15px'}}/>,
    "r_trips": <FaRoute style={{fontSize:'15px'}}/>,
    "r_alerts": <HiMiniBellAlert style={{fontSize:'15px'}}/>,
    "r_tolls": <FaToriiGate style={{fontSize:'15px'}}/>,
    "Stellantis": <MdSatelliteAlt style={{fontSize:'20px'}}/>,
    "Ford": <SiFord style={{fontSize:'20px'}}/>,
    "VW": <FaCarSide style={{fontSize:'20px'}}/>,
    "RidesIQ": <MdGpsFixed  style={{fontSize:'20px'}}/>,
    "Vehicle Insights": <FontAwesomeIcon icon={faRoad} style={{fontSize:'20px'}}/>,
    "Logs": <PiMonitorFill style={{fontSize:'20px'}}/>,
    "location": <FaMapLocationDot style={{fontSize: '20px'}} />,
    "location_tax": <TbCurrencyEuro style={{fontSize: '20px'}}/>,
    "bcf_report": <BiSolidReport style={{fontSize: '20px'}}/>,
    "asa_upload": <LuActivity style={{fontSize: '20px'}}/>,
    "asat_upload": <FaToriiGate style={{fontSize: '20px'}}/>,
    "fleet_status": <HiOutlineStatusOnline style={{fontSize: '20px'}}/>,
    "stolen_vehicle": <HiOutlineExclamationTriangle style={{fontSize: '20px'}} />,
    "fleet_logs": <MdOutlineManageHistory style={{fontSize: '20px'}}/>,
    "audit_logs": <MdOutlineRateReview style={{fontSize: '20px'}}/>,
    "s_eligibility": <CiBookmarkCheck style={{fontSize: '20px'}}/>,
    "s_fetch": <FaCarOn style={{fontSize: '20px'}}/>,
    "s_removefleet": <TbCarOff style={{fontSize: '20px'}}/>,
    "s_addfleet": <GoTasklist style={{fontSize: '20px'}} />,
    "kinesis_enroll": <FaAddressCard style={{fontSize: '20px'}}/>,
    "compatibility_check": <IoMdCheckmarkCircleOutline style={{fontSize: '20px'}}/>,
    "vw_onboard": <FaHandshake style={{fontSize: '20px'}}/>,
    "vw_offboard": <FaHandshakeSimpleSlash style={{fontSize: '20px'}}/>,
    "vw_status": <HiDotsHorizontal style={{fontSize: '20px'}}/>,
    "ridesiq_devices": <MdOnDeviceTraining style={{fontSize: '20px'}}/>,
    "update_imei": <BsQrCode style={{fontSize: '20px'}}/>,
    "tolls_report": <FileText style={{fontSize: '20px'}}/>,
    "vin_movement": <FaRoute style={{fontSize: '20px'}}/>,
    "merged_report": <FileText style={{fontSize: '20px'}}/>,
    "stellantis_check": <FileText style={{fontSize: '20px'}}/>,
    "Nissan": <SiNissan style={{fontSize:'20px'}}/>,
    "n_eligibility": <CiBookmarkCheck style={{fontSize: '20px'}}/>,
    "n_fetch": <FaCarOn style={{fontSize: '20px'}}/>,
    "n_removefleet": <TbCarOff style={{fontSize: '20px'}}/>,
    "n_enrollfleet": <GoTasklist style={{fontSize: '20px'}} />,
  }
  const handleSubMenu = (val) => {
    if (showSubMenu === val){
      setShowSubMenu(false);
    }else{
      setShowSubMenu(val);
    }
  }
  const handleSubMenu2 = () => {
    setShowSubMenu(false);
  }

  useEffect(() => {
    if (searchModuleName === '') {
      setShowSubMenu(false); 
    } else {
      const matched = menuItemsFinal.find(val => 
        val.name.toLowerCase().includes(searchModuleName.toLowerCase()) ||
        (Array.isArray(val.submenu) && val.submenu.some(sub =>
          sub.name.toLowerCase().includes(searchModuleName.toLowerCase())
        ))
      );
      if (matched) setShowSubMenu(matched.name);
    }
  }, [searchModuleName]);

  useEffect(() => {
    axios.get(baseURL + "/get_modules")
      .then((res) => {
        const menuItems = res.data.map((val1) => {
          let submenu = [];
          if ((val1.sub_module).length > 0){
            val1.sub_module.map((val2) => {
              submenu.push({ "name": val2.sub_name, "icon": iconHash[val2.routing], "routing": '/' + val2.routing})
            })
          }
          return { "name": val1.name, "icon": iconHash[val1.name], "routing": '/' + val1.routing, "submenu": submenu }
        })
        // "menuItems", menuItems)
        setMenuItemsFinal(menuItems) 
      });
  }, [])
  
  return (
    <div className="sidebar">
      <div className="sidebarWrapper">
        <div className="sidebarMenu">
            
          <div className="col-auto text-center">
            <Link to="/">  <img src={logo} alt="" className='logo' /> </Link>
          </div>

          <div className='d-flex justify-content-center mt-3'>
              <input
                type="text"
                placeholder="Search modules..."
                value={searchModuleName}
                onChange={(e) => setSearchModuleName(e.target.value)}
                className='border border-primary p-1 focus:border-primary focus:outline-none focus:ring-0'
              />
          </div>
          <ul className="sidebarList">
            {
                menuItemsFinal
                .filter((val) => {
                  const nameMatch = val.name.toLowerCase().includes(searchModuleName.toLowerCase());
                  const subMatch = val.submenu?.some(sub => sub.name.toLowerCase().includes(searchModuleName.toLowerCase()));
                  return nameMatch || subMatch;
                }).map((val, i) => (<React.Fragment key={i}>
                  {val.submenu && (val.submenu).length > 0 ? (
                    <>
                    <NavLink className={showSubMenu === val.name ? 'link-active' : 'link'}>
                      {foundUser['tm_accessRole'][val.name] && foundUser['tm_accessRole'][val.name]['View'] === true &&
                      <li className="sidebarListItem" style={{ float: 'left', maxWidth: 200 }}>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ width: "12vw" }}
                          onClick={() => handleSubMenu(val.name)}
                        >
                          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                            <span>{val.icon}</span>
                            <span>{val.name}</span>
                          </div>

                          {showSubMenu === val.name ? (
                            <GoChevronUp className='mt-1'/>
                          ) : (
                            <FiChevronDown className='mt-1'/>
                          )}
                        </div>

                          {( showSubMenu === val.name || ( searchModuleName !== '' && (
                              val.name.toLowerCase().includes(searchModuleName.toLowerCase()) ||
                              (Array.isArray(val.submenu) && val.submenu.some(sub =>
                                sub.name.toLowerCase().includes(searchModuleName.toLowerCase())
                              ))
                            ))
                        ) && (
                            <ul className="sidebarList sidebar_sub_list">
                            {val.submenu.map((submenuItem, index) => (
                              <NavLink key={index} to={submenuItem.routing} className={({ isActive }) => (isActive ? 'link-active2' : 'link')}>
                                <li className="sidebarListItem2" style={{ float: 'right'}}>
                                  {submenuItem.icon} <span>{submenuItem.name}</span>
                                </li>
                              </NavLink>
                            ))}
                            </ul>
                          )}
                      </li>
                      }
                    </NavLink>
                    </>
                  ):(
                    <NavLink to={val.routing} key={i} end  onClick={handleSubMenu2} className={({ isActive }) => (isActive ? 'link-active' : 'link')}>
                      {foundUser['tm_accessRole'][val.name] && foundUser['tm_accessRole'][val.name]['View'] === true &&
                      <li className="sidebarListItem"  style={{ float: 'left', maxWidth: 200 }}>
                        {val.icon}  <span>{val.name}</span>
                      </li>
                      }
                    </NavLink>
                  )}
                </React.Fragment>
                ))
            }
          </ul>

        </div>
      </div>
    </div>
  )
}